var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6666 39.9667L68.5333 30.6667L69.6666 18.3667L57.6333 15.6333L51.3333 5L40 9.86667L28.6666 5L22.3666 15.6333L10.3333 18.3333L11.4666 30.6667L3.33331 39.9667L11.4666 49.2667L10.3333 61.6L22.3666 64.3333L28.6666 75L40 70.1L51.3333 74.9667L57.6333 64.3333L69.6666 61.6L68.5333 49.3L76.6666 39.9667V39.9667ZM63.5 44.9L61.6333 47.0667L61.9 49.9L62.5 56.4L56.1666 57.8333L53.3666 58.4667L51.9 60.9333L48.6 66.5333L42.6666 63.9667L40 62.8333L37.3666 63.9667L31.4333 66.5333L28.1333 60.9667L26.6666 58.5L23.8666 57.8667L17.5333 56.4333L18.1333 49.9L18.4 47.0667L16.5333 44.9L12.2333 40L16.5333 35.0667L18.4 32.9L18.1 30.0333L17.5 23.5667L23.8333 22.1333L26.6333 21.5L28.1 19.0333L31.4 13.4333L37.3333 16L40 17.1333L42.6333 16L48.5666 13.4333L51.8666 19.0333L53.3333 21.5L56.1333 22.1333L62.4666 23.5667L61.8666 30.0667L61.6 32.9L63.4666 35.0667L67.7666 39.9667L63.5 44.9V44.9Z",
    fill: "#4974E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6333 45.8333L25.9 38.0667L20.9667 43.0333L33.6333 55.7333L58.1 31.2L53.1667 26.2333L33.6333 45.8333Z",
    fill: "#4974E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.fbbe0fb22850ee196c1478ce14db588d.svg";
export { ForwardRef as ReactComponent };